import { svg } from 'lit';
import { type IconBase, createIconComponent } from '../Icon.component';

/** List of icons here : https://lamaille.supernova-docs.io/latest/foundations/iconography-system-xiZRSP4Z#search-7b7542c0-4d44-11ec-8ce5-cb0f56bcf344 **/
export const IconLess = createIconComponent(
    'lr-icon-less',
    svg`
<path xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" d="M5 15H6H26H27V17H26H6H5V15Z" fill="currentcolor"/>
`
);

declare global {
    interface HTMLElementTagNameMap {
        'lr-icon-less': IconBase;
    }
}
